import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css'; 
import ResearchSidebar from '../../Components/ResearchSidebar';
import { makeItem, FilterItem, Item, Nutrition } from '../../item';
import Papa from "papaparse";
import { API_BASE_URL } from '../../utils/apiConfig.js';
const AddRemoveProducts = () => {
    const [activeTab, setActiveTab] = useState('add');
    const [message, setMessage] = useState('');
    const [csvData, setCSVData] = useState([]);
    const fileInputRef = useRef(null);

    // Image Upload State
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    // add product state
    const [productData, setProductData] = useState({
        productName: '', department: '', price: '', shelf: '', aisle: '', 
        description: '', image: 'autoFill.jpg'
    });

    const [nutritionData, setNutritionData] = useState({
        ingredients: '', warnings: '', calories: '', totalFat: '', monounsaturatedFat: '', polyunsaturatedFat: '', 
        transFat: '', totalCarbs: '', totalSugars: '', addedSugar: '', 
        cholesterol: '', sodium: '', fiber: '', protein: '', iron: '', 
        servingSize: '', servingsPerContainer: ''
    });

    // remove product state
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    // clear message on tab change
    useEffect(() => {
        setMessage('');
    }, [activeTab]);

    // handlers
    const handleProductChange = (e) => {
        setProductData({ ...productData, [e.target.name]: e.target.value });
    };

    const handleNutritionChange = (e) => {
        setNutritionData({ ...nutritionData, [e.target.name]: e.target.value });
    };

    // File Selection Handler
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewUrl(URL.createObjectURL(file)); // Create local URL for preview
        }
    };

    const handleSubmitProduct = async (e) => {
        e.preventDefault();

        // Use FormData to send file + data
        const formData = new FormData();
        if (selectedFile) {
            formData.append('productImage', selectedFile);
        }
        formData.append('product', JSON.stringify(productData));
        formData.append('nutrition', JSON.stringify(nutritionData));

        try {
            // Updated to handle multipart/form-data
            await axios.post(`${API_BASE_URL}/api/add-product`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setMessage('Product Added Successfully!');
            
            // Clear image preview on success
            setSelectedFile(null);
            setPreviewUrl(null);

            setTimeout(() => {
                setMessage('');
            }, 10000);
            // Clear forms
        } catch (error) {
            console.error(error);
            setMessage('Error adding product.');
        }
    };

    const handleSearch = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/products/search?q=${searchQuery}`);
            setSearchResults(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Are you sure? This cannot be undone.")) return;
        try {
            await axios.delete(`${API_BASE_URL}/api/products/${id}`);
            setMessage('Product Deleted.');
            setTimeout(() => {
                setMessage('');
            }, 10000);
            handleSearch(); // Refresh list
        } catch (err) {
            console.error(err);
            setMessage('Error deleting product.');
        }
    };
    const handleCSVButton = () => {
        fileInputRef.current.click();
    };

    const handleCSV = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async (results) => {
                const rawData = results.data;
                setCSVData(rawData);

                const products = rawData.map(newProduct =>
                    new FilterItem(
                        makeItem(
                            0,
                            newProduct.product_name,
                            newProduct.price.replace(/[^0-9.]/g, ''),
                            newProduct.image_file_name,
                            newProduct.description,
                            newProduct.ingredients,
                            newProduct.warnings,
                            newProduct.calories.replace(/\D/g, ''),
                            newProduct.total_fat.replace(/\D/g, ''),
                            newProduct.monounsaturated_fat.replace(/\D/g, ''),
                            newProduct.polyunsaturated_fat.replace(/\D/g, ''),
                            newProduct.trans_fat.replace(/\D/g, '') ,
                            newProduct.total_carbs.replace(/\D/g, ''), 
                            newProduct.total_sugars.replace(/\D/g, ''),
                            newProduct.added_sugar.replace(/\D/g, ''),
                            newProduct.cholesterol.replace(/\D/g, ''),
                            newProduct.sodium.replace(/\D/g, ''),
                            newProduct.fiber.replace(/\D/g, ''),
                            newProduct.protein.replace(/\D/g, ''),
                            newProduct.iron.replace(/[^0-9.]/g, ''),
                            newProduct.serving_size,
                            newProduct.servings_per_container
                        ),
                        newProduct.department,
                        newProduct.aisle,
                        newProduct.shelf
                    )
                );

                for (let i = 0; i < products.length; i++) {
                    try {
                        await axios.post(`${API_BASE_URL}/api/add-csv-product`, {
                            productName: products[i].item.name,
                            price: products[i].item.price,
                            productImage: products[i].item.image,
                            description: products[i].item.description,
                            ingredients: products[i].item.nutrition.ingredients,
                            warnings: products[i].item.nutrition.warnings,
                            calories: products[i].item.nutrition.calories,
                            totalFat: products[i].item.nutrition.totalFat,
                            monounsaturatedFat: products[i].item.nutrition.monounsaturatedFat,
                            polyunsaturatedFat: products[i].item.nutrition.polyunsaturatedFat,
                            transFat: products[i].item.nutrition.transFat,
                            totalCarbs: products[i].item.nutrition.totalCarbs, 
                            totalSugars: products[i].item.nutrition.totalSugars,
                            addedSugar: products[i].item.nutrition.addedSugar,
                            cholesterol: products[i].item.nutrition.cholesterol,
                            sodium: products[i].item.nutrition.sodium,
                            fiber: products[i].item.nutrition.fiber,
                            protein: products[i].item.nutrition.protein,
                            iron: products[i].item.nutrition.iron,
                            servingSize: products[i].item.nutrition.servingSize,
                            servingsPerContainer: products[i].item.nutrition.servingsPerContainer,
                            department: products[i].department,
                            aisle: products[i].aisle,
                            shelf: products[i].shelf
                        });
                    } catch (err) {
                        console.error("Error adding row:", err);
                    }
                }
                setMessage('CSV Import Complete!');
            },
        });
    };

    return (
        <main className="dashboard-layout">
            <ResearchSidebar />

            <div className="dashboard-content">
                <h1 className="page-title">Manage Products</h1>
                
                <div className="tab-container">
                    <button className={`tab-btn ${activeTab === 'add' ? 'active' : ''}`} onClick={() => setActiveTab('add')}>Add New Product</button>
                    <button className={`tab-btn ${activeTab === 'remove' ? 'active' : ''}`} onClick={() => setActiveTab('remove')}>Remove Product</button>
                    <button onClick={handleCSVButton}>Select CSV File to read From</button>
                    <input type="file" accept=".csv" ref={fileInputRef} style={{ display: "none" }} onChange={handleCSV} />
                </div>
            
                {message && (
                    <div style={{ padding: '10px', background: '#d4edda', color: '#155724', borderRadius: '8px', marginBottom: '20px' }}>
                        {message}
                    </div>
                )}

                {/* add product form*/}
                {activeTab === 'add' && (
                    <div className="modern-card">
                        <form onSubmit={handleSubmitProduct}>
                            <h3 style={{ marginTop: 0, borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Basic Information</h3>
                            
                            <div className="grid-2-col">
                                <div className="form-group">
                                    <label className="form-label">Product Name *</label>
                                    <input className="modern-input" name="productName" onChange={handleProductChange} required />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Department *</label>
                                    <input className="modern-input" name="department" onChange={handleProductChange} required />
                                </div>
                                
                                <div className="form-group">
                                    <label className="form-label">Price ($) *</label>
                                    <input className="modern-input" type="number" step="0.01" name="price" placeholder="e.g. 3.99" onChange={handleProductChange} required />
                                    <small style={{ color: '#666', fontSize: '0.85rem', marginTop: '5px', display: 'block' }}>Must be a numeric value</small>
                                </div>
                                
                                <div className="form-group">
                                    <label className="form-label">Location (Aisle/Shelf) *</label>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <input className="modern-input" placeholder="Aisle" name="aisle" onChange={handleProductChange} style={{ flex: 1 }} required />
                                        <input className="modern-input" placeholder="Shelf" name="shelf" onChange={handleProductChange} style={{ flex: 1 }} required />
                                    </div>
                                </div>

                                <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                                    <label className="form-label">Product Image</label>
                                    <div className="image-upload-flex" style={{ display: 'flex', gap: '20px', alignItems: 'center', marginTop: '10px' }}>
                                        <div className="preview-box" style={{ 
                                            width: '100px', height: '100px', border: '1px dashed #ccc', 
                                            borderRadius: '8px', display: 'flex', alignItems: 'center', 
                                            justifyContent: 'center', overflow: 'hidden', background: '#f9f9f9' 
                                        }}>
                                            {previewUrl ? <img src={previewUrl} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <small style={{color: '#999'}}>No Image</small>}
                                        </div>
                                        <input type="file" accept="image/*" onChange={handleFileChange} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">Description (Enter "-" if unknown) *</label>
                                <textarea className="modern-input" name="description" rows="3" onChange={handleProductChange} required />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Ingredients (Enter "-" if unknown) *</label>
                                <textarea className="modern-input" name="ingredients" rows="3" onChange={handleNutritionChange} required />
                            </div>

                            <h3 style={{ marginTop: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Nutrition Facts (Enter "-" if unknown) *</h3>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>
                                {Object.keys(nutritionData)
                                    .filter(key => key !== 'ingredients')
                                    .map((key) => (
                                        <div key={key} className="form-group">
                                            <label className="form-label" style={{textTransform: 'capitalize'}}>{key.replace(/([A-Z])/g, ' $1')}</label>
                                            <input className="modern-input" name={key} type="text" onChange={handleNutritionChange} required />
                                        </div>
                                ))}
                            </div>

                            <div style={{ marginTop: '2rem', textAlign: 'right' }}>
                                <button type="submit" className="btn-primary">Save Product</button>
                            </div>
                        </form>
                    </div>
                )}

                {/* remove product Section (Logic remains the same) */}
                {activeTab === 'remove' && (
                    <div className="modern-card">
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                            <input className="modern-input" placeholder="Search product by name..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleSearch()} style={{ flex: 1 }} />
                            <button onClick={handleSearch} className="btn-primary">Search</button>
                        </div>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {searchResults.map(p => (
                                <li key={p.productId} style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', borderBottom: '1px solid #eee', alignItems: 'center', background: '#fff' }}>
                                    <div>
                                        <strong style={{ fontSize: '1.1rem' }}>{p.productName}</strong>
                                        <div style={{ color: '#666', fontSize: '0.9rem' }}>{p.department}</div>
                                    </div>
                                    <button onClick={() => handleDelete(p.productId)} className="btn-danger">Delete</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </main>
    );
};

export default AddRemoveProducts;